<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title class="text-h5"> Provide Feedback </v-card-title>

      <v-card-text>
        <v-textarea
          v-model="feedback"
          label="Why did you make this change? Help us improve!"
          rows="3"
          auto-grow
          variant="outlined"></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" variant="text" @click="dialog = false"> Cancel </v-btn>
        <v-btn color="primary" variant="tonal" @click="submitFeedback"> Submit </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";

const dialog = ref(false);
const feedback = ref("");

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  fieldId: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue", "submit"]);

watch(
  () => props.modelValue,
  (newVal) => {
    dialog.value = newVal;
  }
);

watch(
  () => dialog.value,
  (newVal) => {
    emit("update:modelValue", newVal);
  }
);

const submitFeedback = () => {
  emit("submit", {
    fieldId: props.fieldId,
    feedback: feedback.value,
  });
  dialog.value = false;
  feedback.value = "";
};
</script>
